import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"class",
    list_id:"class_list",
    x_column_list_arr:[
      {"key":"a_name","name":"클래스명","width":"280","is_show":"1"},
      {"key":"a_type","name":"구분","width":"70","is_show":"1"},
      {"key":"a_is_supply_money","name":"청구","width":"100","is_show":"1"},
      {"key":"a_supply_money","name":"수업료","width":"100","is_show":"1"},
      {"key":"row_view_teacher","name":"선생님","width":"110","is_show":"1"},
      {"key":"row_view_stu_cnt","name":"인원","width":"80","is_show":"1"},
      {"key":"row_view_memo","name":"메모","width":"180","is_show":"1"},
      {"key":"row_view_manage","name":"관리","width":"120","is_show":"1"},
      {"key":"row_view_period","name":"기간","width":"160","is_show":""},
      {"key":"row_view_day","name":"수업요일","width":"180","is_show":""},
      // {"key":"a_create_date","name":"작성일","width":"180","is_show":"1"},
      // {"key":"a_update_date","name":"수정일","width":"180","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':300,
      'order_id':'a_name',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_class_name_like":"",
      "s_stu_name_like":"",
      "s_stu_phone_like":"",
      "s_stu_school_name_like":"",
      "s_stu_stu_grade":"",
      "s_teacher_like":"",
      "s_is_supply_money":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;